<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-store-alt"></i> Regionais</h3>
      </div>
    </div>
    <RegionalAdd v-if="showAdd" ref="RegionalAdd" v-on:Back="onBack" />
    <RegionalList v-else ref="RegionalList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import RegionalAdd from './components/add/regionalAdd.vue'
import RegionalList from './components/list/regionalList.vue'

export default {
  name: 'Regional',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    RegionalAdd,
    RegionalList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.RegionalAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.RegionalList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/regional/regional.vue